if ( typeof CartForm !== 'function' ) {
  class CartForm extends HTMLElement {

    constructor(){
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems(){

      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

        const remove = item.querySelector('.remove');
        if ( remove ) {
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');
          remove.addEventListener('click', (e)=>{
            e.preventDefault();
            this.updateCartQty(item, 0);
          })
        }

        const qty = item.querySelector('.qty');
        if ( qty ) {
          qty.addEventListener('input', debounce(e=>{
            e.preventDefault();
            e.target.blur();
            this.updateCartQty(item, parseInt(qty.value));
          }, 500));
          qty.addEventListener('click', (e)=>{
            e.target.select();
          })
        }

      })

    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add('processing');
      document.body.classList.add('fetching');

      // Disable cart / checkout buttons while processing
      document.querySelectorAll('#ViewCart, #CheckOut').forEach(element => {
        element.setAttribute('disabled', 'disabled');
      });

      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }

      const maxQuantity = parseInt(item.dataset.inventory);
      let quantityAlert = '';
      let quantity = newQty;
      if ((quantity > maxQuantity) && maxQuantity > 0) {
        quantity = maxQuantity
        quantityAlert = `Only ${maxQuantity} ${item.dataset.title} available`;
      }

      const mainProductId = item.dataset.id;

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          // Prepare updates for main product and associated service items
          const updates = {};
          const mainProductItem = cart.items.find(cartItem => cartItem.id === parseInt(mainProductId));

          // Update main product quantity and associated service items
          updates[mainProductId] = quantity;
          const serviceItems = cart.items.filter(cartItem =>
            cartItem.properties['_associated-product-id'] === mainProductId
          );

          serviceItems.forEach(serviceItem => {
            const serviceItemKey = parseInt(serviceItem.key)
            updates[serviceItemKey] = quantity;
          });

          // Perform cart update request
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            body: JSON.stringify({ updates })
          });
        })
        .then(response => response.json())
        .then(response => {
          if (response.status === 422 || quantityAlert) {
            // Wrong stock logic alert
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            if (quantityAlert) {
              alert.innerHTML = quantityAlert
            } else {
              alert.innerHTML = typeof result.description === 'string' ? result.description : result.message;
            }
          }
          return fetch('?section_id=helper-cart');
        })
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
          const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

          const cartItems = document.getElementById('AjaxCartForm');
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
            elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
          });
          document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
            elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
          });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

          const event = new Event('cart-updated');
          this.dispatchEvent(event);
        })
        .catch(e => {
          console.error('Error handling cart update:', e);
          let errorAlert = document.createElement('span');
          errorAlert.classList.add('alert', 'alert--error');
          errorAlert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(errorAlert);
        })
        .finally(() => {
          this.form.classList.remove('processing');
          document.body.classList.remove('fetching');

          // Enable cart / checkout buttons
          document.querySelectorAll('#ViewCart, #CheckOut').forEach(element => {
            element.removeAttribute('disabled');
          });

          document.dispatchEvent(new CustomEvent('updateCartQty', { detail: { item: item, newQty: newQty } }));
        });
    }

  }


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
    customElements.define('cart-form', CartForm);
  }

}

if ( typeof CartProductQuantity !== 'function' ) {

  class CartProductQuantity extends HTMLElement {
    constructor(){
      super();
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
    }
    changeCartInput(){
      setTimeout(()=>{
        document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
      }, 50);
    }
  }

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }

}

// method for apps to tap into and refresh the cart

if ( ! window.reloadCart ) {

  window.reloadCart = () => {

    fetch('?section_id=helper-cart')
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });
        document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        })

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
        if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
          document.querySelector('[data-js-site-cart-sidebar]').show();
        }

        if ( document.querySelector('cart-recommendations') ) {
          document.querySelector('cart-recommendations').innerHTML = '';
          document.querySelector('cart-recommendations').generateRecommendations();
        }
      })
      .then(() => {
        document.dispatchEvent(new Event('cartUpdated'))
      })
  }

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body
            });
          }, 150)
        );
      }
    }
  );
}
